import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { red6 } from 'approot/shared/styles/colours.style';
import { boxShadowBlack12 } from 'approot/shared/styles/borders.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';

export const DiscussionViewWrapper = styled.div`
  position: relative;
`;

export const DiscussionViewAnswerIndicator = styled(SecondaryButtonIcon).attrs({
  $borderRadius: 40,
})`
  ${boxShadowBlack12}
  position: absolute;
  right: -${rem(spacing8)};
  top: -${rem(spacing8)};
  z-index: 1;

  &:after {
    content: '';
    background-color: ${red6};
    border-radius: ${rem(12)};
    width: ${rem(12)};
    height: ${rem(12)};
    position: absolute;
    right: ${rem(spacing8)};
    top: ${rem(spacing8)};
  }
`;
